import './rule_edit_view.js.coffee';# Added by Script 
Monitoring.Views ||= {}

class Monitoring.Views.TicketRuleEditView extends Monitoring.Views.RuleEditView
  template: JST["backbone/templates/monitoring/rules/ticket_rule_edit_modal"]

  initialize: (@options = {}) ->
    @availableUserGroups  = @options.availableUserGroups
    @availableOperators   = @options.availableOperators
    @availableTicketStatuses  = @options.availableTicketStatuses
    @availableTemplates = @options.availableTemplates
    super

  render: ->
    @$el.html(@template())
    @renderGeneralTab()
    @renderScConditionTab()
    @renderTicketConditionTab()
    @renderActionsTab()

    @initializeModal()
    @initializeChosen()
    @updateSaveButtonStatus()
    @

  renderTicketConditionTab: =>
    @ticketConditionEditView = new Monitoring.Views.TicketConditionEditView({
      ticketCondition: @rule.get('ticket_condition')
      availableTags: @availableTags
      availableGroups: @availableGroups
      availableTicketStatuses: @availableTicketStatuses
      availableOperators: @availableOperators
      editView: @$el
    })
    @$el.find('.tab-content #ticket-condition').html(@ticketConditionEditView.render().el)
    @listenTo(@ticketConditionEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderActionsTab: ->
    @renderTicketActionsTab()
    @$el.find('.tab-content #actions').html(@actionsEditView.render().el)
    @listenTo(@actionsEditView, 'changed-mandatory-field', @updateSaveButtonStatus)

  renderTicketActionsTab: =>
    @actionsEditView = new Monitoring.Views.TicketActionsEditView({
      ticketActions: @rule.get('actions')
      availableOperators: @availableOperators
      availableUserGroups: @availableUserGroups
      availableTemplates: @availableTemplates
    })

  viewsInTabs: ->
    [@ruleGeneralEditView, @scConditionEditView, @ticketConditionEditView, @actionsEditView]

  allMandatoryFieldsAreFilled: =>
    _.all(@viewsInTabs(), (view) -> view.allMandatoryFieldsAreFilled())

  onClickSave: ->
    @rule.set('ticket_condition', @ticketConditionEditView.getCondition())
    super

  initializeChosen: ->
    @$el.find('.chosen-select').chosen({
      width: '360px'
      enable_split_word_search: true
      search_contains: true
    }).on('chosen:showing_dropdown', @_closeOpenChosen)
